import { ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryDocuments = ErrorBoundary;
